import React from "react";
import { useAudio } from "../../Context/AudioContext";
import musica from "../../Imagenes/musica.gif";
import Play from "../../Imagenes/Play.png";

function Reproductor() {
  const { isPlaying, play, pause } = useAudio();

  const handleClick = () => {
    isPlaying ? pause() : play();
  };

  const positionStyle = {
    position: "fixed",
    bottom: "40px",
    right: "10px",
    zIndex: 999,
  };

  return (
    <div className="container" style={positionStyle}>
      <button
        className="bg-verde3 hover:bg-verde3 text-white font-bold py-2 px-4 rounded-full"
        onClick={handleClick}
      >
        {isPlaying ? (
          <img className="h-10" src={musica} alt="GIF de música" />
        ) : (
          <img className="h-10" src={Play} alt="Botón de play" />
        )}
      </button>
    </div>
  );
}

export default Reproductor;

